export enum LanguageContentTypeEnum {
        Label = 5,
        Toastr = 6,
        Alert = 7,
        Tooltip = 8,
        Placeholder = 9,
        GridHeader = 10,
        ServerMessage = 11,
}
